module.exports = __webpack_public_path__ + "img/icon-8.b9648955.svg";